import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CustomButton from '../button';

import DownloadIcon from '../../assets/images/download-icon.svg';
import css from './certificates-wrapper.scss';

const CertificatesWrapper = (props) => {
    const {
        children,
        heading,
        onDownload,
        downloadDisabled,
        downloadText,
        className = '',
        templateType,
        downloadCertificatesState
    } = props;

    const { isActive, downloadType } = downloadCertificatesState;
    const hasSpinner = isActive && templateType === downloadType;
    return (
        <div className={css['certificates-wrapper']}>
            <div className={css.header}>
                <div className={css.heading}>
                    <span>{heading}</span>
                </div>
                <CustomButton
                    className={`${css['download-button']} ${downloadDisabled ? css.disabled : ''}`}
                    text={downloadText}
                    type={CustomButton.LOZENGE}
                    size={CustomButton.LARGE}
                    icon={hasSpinner ? '' : DownloadIcon}
                    alignIcon={CustomButton.RIGHT}
                    hasSpinner={hasSpinner}
                    btnType={templateType}
                    disabled={downloadDisabled}
                    onClick={onDownload}
                />
            </div>
            <div className={`${css.certificates} ${className}`}>
                {children}
            </div>
        </div>
    );
};

CertificatesWrapper.propTypes = {
    children: PropTypes.node,
    heading: PropTypes.string,
    onDownload: PropTypes.func,
    downloadDisabled: PropTypes.bool,
    downloadText: PropTypes.string,
    className: PropTypes.string,
    templateType: PropTypes.string,
    downloadCertificatesState: PropTypes.object
};


function mapStateToProps(state) {
    return { downloadCertificatesState: state.downloadCertificatesState };
}

export default connect(mapStateToProps)(CertificatesWrapper);



// WEBPACK FOOTER //
// ./components/certificates-wrapper/certificates-wrapper.js